import { render } from "./ModalOlvidasteClave.vue?vue&type=template&id=33debd1c&scoped=true"
import script from "./ModalOlvidasteClave.vue?vue&type=script&lang=js"
export * from "./ModalOlvidasteClave.vue?vue&type=script&lang=js"

import "./ModalOlvidasteClave.vue?vue&type=style&index=0&id=33debd1c&scoped=true&lang=css"

import exportComponent from "/srv/repos/ayuda/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33debd1c"]])

export default __exports__